import React from "react";
import TagButton from "../common/TagButton";

const boot41Img = "https://storage.googleapis.com/think41-web-new/assets/Career/Boot41-Image.png";
const BackgroundImg = "https://storage.googleapis.com/think41-web-new/assets/Career/Background.png";
const boot41video = "https://storage.googleapis.com/think41-web-new/assets/Career/boot41.mp4";

const Boot41 = () => {
  return (
    <div className="h-full w-full overflow-x-hidden relative">
      {/* Background */}
      <div
        aria-hidden="true"
        style={{
          backgroundImage: `url(${BackgroundImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.9,
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      <section
        className="w-[1200px] max-w-full mx-auto flex flex-col relative px-4 md:px-0 md:mb-0 mb-[36px]"
        id="boot41"
        style={{ minHeight: "520px", zIndex: 1 }}
      >
        <div style={{ height: 36 }} />

        {/* Heading Section */}
        <div className="flex flex-col relative z-[1] w-full">
          <TagButton text="Graduate Program" />
          <h1
            className="text-white font-semibold font-montserrat leading-tight mb-4 mt-9 md:mt-[36px] w-full"
            style={{
              fontSize: "40px",
              lineHeight: "133.1%",
              marginBottom: "16px",
            }}
          >
            Boot41: Launch Your Career into the Future of AI
          </h1>
          <div
            className="font-roboto text-[16px] text-white font-light leading-[28px] mt-4 text-justify"
            style={{ maxWidth: "684px" }}
          >
            Boot41 is our exclusive bootcamp designed to equip engineers and
            developers with hands-on experience, mentorship, and AI-driven
            workflows to fast-track their careers
          </div>
        </div>

        {/* Images Section */}
        <div className="flex flex-col md:flex-row items-center md:items-end gap-[26px] w-full mt-[36px] relative z-[1]">
          <div className="relative w-full md:w-[750px] h-[300px] md:h-[400px] rounded-[18px] overflow-hidden flex items-end justify-end">
            <img
              src={boot41Img}
              alt="Bootcamp"
              className="w-full h-full object-cover rounded-[18px]"
            />
          </div>
          {/* <div className="relative w-full md:w-[750px] h-[300px] md:h-[400px] rounded-[18px] overflow-hidden flex items-end justify-end bg-white"> */}
          <div className="w-full h-full">
          <video
  src={boot41video}
  width="100%"
  height="100%"
  autoPlay
  muted
  controls
  playsInline
  

></video>
          </div>

          {/* </div> */}
        </div>

        {/* Stats Section */}
        <div className="flex flex-col md:flex-row w-full h-auto md:h-[80px] justify-between items-start md:items-center mt-[36px] relative z-[1] gap-8 md:gap-0 mb-[36px]">
          <div className="flex flex-col items-start flex-1 w-full max-w-max">
            <span
              className="text-[32px] font-roboto text-white leading-[38px]"
              style={{ letterSpacing: "-1.067px" }}
            >
              75%
            </span>
            <span
              className="font-montserrat text-[24px] font-normal text-white mt-2 leading-[30px] max-w-max tracking-[-0.107px]
"
              style={{ letterSpacing: "-0.107px" }}
            >
              conversion rate to full-time offers
            </span>
          </div>
          <div className="h-full w-[1px] bg-white"></div>
          <div className="flex flex-col items-start flex-1 max-w-max">
            <span
              className="text-[32px] font-roboto text-white leading-[38px]"
              style={{ letterSpacing: "-1.067px" }}
            >
              50+
            </span>
            <span
              className="font-montserrat text-[24px] font-normal text-white mt-2 leading-[30px] tracking-[-0.107px]
"
              style={{ letterSpacing: "-0.107px" }}
            >
              engineers trained across two cohorts
            </span>
          </div>
          <div className="h-full w-[1px] bg-white"></div>
          <div className="flex flex-col items-start flex-1 max-w-max">
            <span
              className="text-[32px] font-roboto text-white leading-[38px]"
              style={{ letterSpacing: "-1.067px" }}
            >
              30+
            </span>
            <span
              className="font-montserrat text-[24px] font-normal text-white mt-2 leading-[30px] tracking-[-0.107px]
"
              style={{ letterSpacing: "-0.107px" }}
            >
              GenAI mini apps built
            </span>
          </div>
        </div>
      </section>

      {/* Extra styles */}
      <style jsx>{`
        body {
          overflow-x: hidden;
        }

        @media (max-width: 768px) {
          #boot41 h1 {
            font-size: 24px !important;
            margin-top: 36px !important;
          }
          #boot41 div.font-roboto {
            font-size: 16px !important;
          }
          #boot41
            .flex.flex-col.md\\:flex-row.w-full.h-auto.md\\:h-\\[66px\\].justify-between.items-start.mt-\\[36px\\].relative.z-\\[1\\].gap-8.md\\:gap-0 {
            align-items: flex-start !important;
          }
          #boot41
            .flex.flex-col.md\\:flex-row.w-full.h-auto.md\\:h-\\[66px\\].justify-between.items-start.mt-\\[36px\\].relative.z-\\[1\\].gap-8.md\\:gap-0
            > div {
            align-items: flex-start !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Boot41;
